import { render } from "./UnloggedBar.vue?vue&type=template&id=27a36d41&scoped=true"
import script from "./UnloggedBar.vue?vue&type=script&lang=js"
export * from "./UnloggedBar.vue?vue&type=script&lang=js"

import "./UnloggedBar.vue?vue&type=style&index=0&id=27a36d41&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27a36d41"]])

export default __exports__